import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type UserInfo = {
  id: string;
  email: string;
  status: number;
  icon: string;
  sourceType: string;
  userDistrict: string;
  lastLoginTime: string;
  country: string;
};

interface userInfoState {
  userInfo: UserInfo;
  setUserInfo: (value: object) => void;
  getUserInfo: () => UserInfo;
  removeUserInfo: () => void;
}

const initialValue = {
  id: "",
  email: "",
  status: 0,
  icon: "",
  sourceType: "",
  userDistrict: "",
  lastLoginTime: "",
  country: "",
};

const userInfoStore = create<userInfoState>()(
  persist(
    (set, get) => ({
      userInfo: initialValue,
      setUserInfo: (value: Partial<UserInfo>) => {
        set({ userInfo: { ...get().userInfo, ...value } });
      },
      getUserInfo: () => get().userInfo,
      removeUserInfo: () => set({ userInfo: initialValue }),
    }),
    {
      name: "userInfo",
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);

export default userInfoStore;
